import React from 'react';
import { motion } from 'framer-motion';
import { CalendarIcon } from 'lucide-react';
export const BOOKING_URL = 'https://shorturl.at/et0N2';

/** Small, persistent invitation to book a meeting — visible on every page. */
export function BookMeetingButton() {
  return <motion.a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" initial={{
    opacity: 0,
    y: 16
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    delay: 0.6,
    duration: 0.4,
    ease: [0.22, 1, 0.36, 1]
  }} whileHover={{
    scale: 1.04
  }} whileTap={{
    scale: 0.97
  }} aria-label="Book a meeting with Snakker (opens in a new tab)" className="fixed bottom-5 right-5 z-40 inline-flex items-center gap-2 rounded-full bg-white py-2.5 pl-3 pr-4 text-[13px] font-bold text-[var(--fg)] shadow-[0_14px_34px_-14px_rgba(14,27,51,0.45)] ring-1 ring-[var(--fg)]/10 transition-colors hover:bg-[var(--fg)] hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--brand)] focus-visible:ring-offset-2 sm:bottom-6 sm:right-6" data-id="element-236" data-mp="87ad064lzsw4">
      <CalendarIcon className="h-4 w-4 text-[var(--brand)]" aria-hidden="true" data-id="element-237" data-mp="2x5m6v4k8to06" />
      Book a meeting
    </motion.a>;
}